import { color, font, query, space } from '@design/templateFns';
import styled from 'styled-components';

// Carousel styles seemed lengthy enough to warrant it's own stylesheet

//Images Section
export const ImageSection = styled.div`
  // Swiper styles
  .swiper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }

  > .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }

  .swiper-vertical > .swiper-wrapper {
    flex-direction: column;
  }
  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }
  .swiper-android .swiper-slide,
  .swiper-wrapper {
    transform: translate3d(0px, 0, 0);
  }
  .swiper-pointer-events {
    touch-action: pan-y;
  }
  .swiper-pointer-events.swiper-vertical {
    touch-action: pan-x;
  }
  .swiper-slide {
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: transform;
  }
  .swiper-slide-invisible-blank {
    visibility: hidden;
  }
  /* Auto Height */
  .swiper-autoheight,
  .swiper-autoheight .swiper-slide {
    height: auto;
  }
  .swiper-autoheight .swiper-wrapper {
    align-items: flex-start;
    transition-property: transform, height;
  }
  .swiper-backface-hidden .swiper-slide {
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  /* CSS Mode */
  .swiper-css-mode > .swiper-wrapper {
    overflow: auto;
    scrollbar-width: none;
    /* For Firefox */
    -ms-overflow-style: none;
    /* For Internet Explorer and Edge */
  }
  .swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {
    display: none;
  }
  .swiper-css-mode > .swiper-wrapper > .swiper-slide {
    scroll-snap-align: start start;
  }
  .swiper-horizontal.swiper-css-mode > .swiper-wrapper {
    scroll-snap-type: x mandatory;
  }
  .swiper-vertical.swiper-css-mode > .swiper-wrapper {
    scroll-snap-type: y mandatory;
  }
  .swiper-centered > .swiper-wrapper::before {
    content: '';
    flex-shrink: 0;
    order: 9999;
  }
  .swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {
    margin-inline-start: var(--swiper-centered-offset-before);
  }
  .swiper-centered.swiper-horizontal > .swiper-wrapper::before {
    height: 100%;
    min-height: 1px;
    width: var(--swiper-centered-offset-after);
  }
  .swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {
    margin-block-start: var(--swiper-centered-offset-before);
  }
  .swiper-centered.swiper-vertical > .swiper-wrapper::before {
    width: 100%;
    min-width: 1px;
    height: var(--swiper-centered-offset-after);
  }
  .swiper-centered > .swiper-wrapper > .swiper-slide {
    scroll-snap-align: center center;
  }
  .swiper-virtual .swiper-slide {
    -webkit-backface-visibility: hidden;
    transform: translateZ(0);
  }
  .swiper-virtual.swiper-css-mode .swiper-wrapper::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
  }
  .swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after {
    height: 1px;
    width: var(--swiper-virtual-size);
  }
  .swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after {
    width: 1px;
    height: var(--swiper-virtual-size);
  }
  .swiper-pagination {
    position: absolute;
    text-align: center;
    transition: 300ms opacity;
    transform: translate3d(0, 0, 0);
    z-index: 10;
  }
  .swiper-pagination.swiper-pagination-hidden {
    opacity: 0;
  }
  .swiper-pagination-disabled > .swiper-pagination,
  .swiper-pagination.swiper-pagination-disabled {
    display: none !important;
  }
  /* Common Styles */
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: ${space('xl')};
    left: 0;
    width: 100%;
    height: ${space('sm')};
    display: flex;
    gap: ${space('sm')};
    justify-content: end;
    padding-right: ${space('xl')};
    box-sizing: border-box;

    @media screen and (${query.atLeast('tablet')}) {
      bottom: ${space('x6')};
      justify-content: center;
      padding-right: 0;
    }
  }
  /* Bullets */
  /* Bullets */
  .swiper-pagination-bullet {
    width: ${space('sm')};
    height: ${space('sm')};
    display: block;
    border-radius: 50%;
    background: ${color('bg')};
    opacity: 0.45;
  }
  button.swiper-pagination-bullet {
    border: none;
    margin: 0;
    padding: 0;
    box-shadow: none;
    -webkit-appearance: none;
    appearance: none;
  }
  .swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer;
  }
  .swiper-pagination-bullet:only-child {
    display: none !important;
  }
  .swiper-pagination-bullet-active {
    opacity: 1;
    background: ${color('bg')};
    box-shadow: inset 0px 0px 3px 0px rgba(0, 0, 0, 1) !important;
    filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.3)) !important;
  }
  .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
  .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0;
  }
  .swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
  .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
  }
  .swiper-horizontal
    > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet,
  .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet {
    transition: 200ms transform, 200ms left;
    box-shadow: inset 0px 0px 3px 0px rgba(0, 0, 0, 1) !important;
    filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.3)) !important;
  }

  .swiper-pagination-bullet .swiper-pagination-bullet-active .swiper-pagination-bullet-active-main {
    box-shadow: inset 0px 0px 3px 0px rgba(0, 0, 0, 1) !important;
    filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.3)) !important;
  }

  .bWfJQB
    .swiper-horizontal
    > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet,
  .bWfJQB
    .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet {
    box-shadow: inset 0px 0px 3px 0px rgba(0, 0, 0, 1) !important;
    filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.3)) !important;
  }

  .swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transition: 200ms transform, 200ms right;
    box-shadow: inset 0px 0px 3px 0px rgba(0, 0, 0, 1) !important;
    filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.3)) !important;
  }
  /* a11y */
  .swiper .swiper-notification {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    opacity: 0;
    z-index: -1000;
  }
  .swiper-free-mode > .swiper-wrapper {
    transition-timing-function: ease-out;
    margin: 0 auto;
  }
  .swiper-grid > .swiper-wrapper {
    flex-wrap: wrap;
  }
  .swiper-grid-column > .swiper-wrapper {
    flex-wrap: wrap;
    flex-direction: column;
  }
  .swiper-fade.swiper-free-mode .swiper-slide {
    transition-timing-function: ease-out;
  }
  .swiper-fade .swiper-slide {
    pointer-events: none;
    transition-property: opacity;
  }
  .swiper-fade .swiper-slide .swiper-slide {
    pointer-events: none;
  }
  .swiper-fade .swiper-slide-active,
  .swiper-fade .swiper-slide-active .swiper-slide-active {
    pointer-events: auto;
  }
  //Previous and Next buttons
  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    margin-top: 0;
    z-index: 10;
    cursor: pointer;
    color: ${color('bg')};
  }
  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    opacity: 1;
    cursor: auto;
    color: ${color('gray3')};
    pointer-events: none;
  }
  .swiper-button-prev.swiper-button-hidden,
  .swiper-button-next.swiper-button-hidden {
    opacity: 0;
    cursor: auto;
    pointer-events: none;
  }
  .swiper-navigation-disabled .swiper-button-prev,
  .swiper-navigation-disabled .swiper-button-next {
    display: none !important;
  }

  .swiper-button-prev,
  .swiper-rtl .swiper-button-next {
    left: ${space('xl')};
    right: auto;

    @media screen and (${query.below('tablet')}) {
      left: ${space('md')};
    }
  }
  .swiper-button-next,
  .swiper-rtl .swiper-button-prev {
    right: ${space('xl')};
    left: auto;

    @media screen and (${query.below('tablet')}) {
      right: ${space('md')};
    }
  }
  .swiper-button-prev:after,
  .swiper-rtl .swiper-button-next:after,
  .swiper-button-next:after,
  .swiper-rtl .swiper-button-prev:after {
    content: none;
  }
  .swiper-button-lock {
    display: none;
  }
`;

export const ImageLinerGradientOverlay = styled.div`
  // TODO: find a way to get gradient over image without this extra div
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 25;
  background: linear-gradient(0.55deg, rgba(0, 0, 0, 0.4) 0.6%, rgba(0, 0, 0, 0) 40%);
`;

export const ImageDetails = styled.div`
  position: absolute;
  bottom: ${space('xl')};
  left: ${space('xl')};
  z-index: 30;
  color: ${color('bg')};
  display: flex;
  flex-direction: column;
  align-items: start;

  @media screen and (${query.atLeast('tablet')}) {
    left: auto;
    top: auto;
    right: ${space('x6')};
    bottom: ${space('x6')};
    align-items: end;
  }

  a {
    display: flex;
    flex-direction: column;
    align-items: start;
    color: ${color('bg')};
    text-decoration: none;

    @media screen and (${query.atLeast('tablet')}) {
      align-items: end;
    }

    > * {
      border-bottom: 1px solid transparent;
      transition: border-color 0.2s ease-in-out;
    }

    &:visited {
      color: ${color('bg')};
    }

    &:hover {
      color: ${color('bg')};
      > * {
        border-color: ${color('bg')};
      }
    }
  }
`;
export const ImageDetailHeader = styled.h4`
  flex: 0 1 auto;
  width: max-content;
  ${font('subhead-xs')};
  line-height: 1.05;
  padding-bottom: 0;
  margin-bottom: ${space('xs')};

  @media screen and (${query.atLeast('tablet')}) {
    ${font('subhead-sm')};
    line-height: 1.05;
  }
`;
export const ImageDetailSubHeader = styled.h5`
  flex: 0 1 auto;
  width: max-content;
  ${font('body-sm-light')};
  line-height: 1.05;
  padding-bottom: 0;

  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md-light')};
    line-height: 1.05;
  }
`;
